import { ThemeDefinition } from 'vuetify';

export const mathematics: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#BE77A6',
    'on-subject-original': '#FFFFFF',
    subject: '#AE5690',
    'on-subject': '#FFFFFF',
    primary: '#87406F',
    'on-primary': '#FFFFFF',
    'primary-container': '#E6CBDD',
    'on-primary-container': '#291422',
    secondary: '#6D5063',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#DED3DB',
    'on-secondary-container': '#231A20',
    surface: '#FCF7FB',
    'on-surface': '#201D1F',
    'on-surface-medium': '#50494E',
    'on-surface-low': '#9E949B',
    outline: '#867982',
    'outline-variant': '#CFC9CD',
    'inverse-surface': '#422438',
    'inverse-on-surface': '#F6EEF4',
    'inverse-primary': '#DEBAD2',
    'surface-dim': '#EBC2DD',
    'surface-bright': '#FEFBFD',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#FAF0F6',
    'surface-container': '#F7E8F2',
    'surface-container-high': '#F2D9EA',
    'surface-container-highest': '#F0D1E5',
  },
};

export const mathematicsDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#BE77A6',
    'on-subject-original': '#FCF8FA',
    subject: '#D4A6C4',
    'on-subject': '#291422',
    primary: '#E4C8DB',
    'on-primary': '#291422',
    'primary-container': '#673255',
    'on-primary-container': '#F7EEF4',
    secondary: '#D8CAD3',
    'on-secondary': '#231A20',
    'secondary-container': '#584150',
    'on-secondary-container': '#F4F0F3',
    surface: '#181016',
    'on-surface': '#F3F2F2',
    'on-surface-medium': '#CFC9CD',
    'on-surface-low': '#867982',
    outline: '#9E949B',
    'outline-variant': '#6B6168',
    'inverse-surface': '#EDDEE8',
    'inverse-on-surface': '#281522',
    'inverse-primary': '#452139',
    'surface-dim': '#150E13',
    'surface-bright': '#462F3E',
    'surface-container-lowest': '#120C10',
    'surface-container-low': '#1E151B',
    'surface-container': '#281B23',
    'surface-container-high': '#34232E',
    'surface-container-highest': '#432D3C',
  },
};
